$fontSize: 14pt;

.practiceplaceButton {
  margin: 0.5em auto;
  text-align: center;
}

.onskelistebeskrivelse {
  font-size: $fontSize;
  text-align: left;
}

.onskelisteTilDatoLabel {
  font-size: $fontSize;
  margin: auto;

  p {
    display: inline-block;
    margin: 0.25em 1em 0 0;
  }
}

.onskelisteButtons {
  text-align: right;
}

.onskelisteCheckbox {
  & * {
    font-size: $fontSize !important;
  }
}

.checboxPadding {
  padding-top: 0.5em;
}

.maxOnsker {
  min-width: 25%;
  width: 7.5em;
}
